var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "skeletonDomRef",
    staticClass: "image-container",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.toggleShow.apply(null, arguments);
      }
    }
  }, [_c('img', {
    class: ['message-image', !_vm.isPC && 'message-image-h5'],
    attrs: {
      "src": _vm.props.content.url,
      "width": _vm.props.content.width,
      "height": _vm.props.content.height
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }